import React, { useState } from 'react';
import { Form, Input, Button, Card, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import SwirlCanvas from './SwirlCanvas';
import './Login.css';

const Login = () => {
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoading(true);
    const result = await login(values.username, values.password);
    setLoading(false);

    if (result.success) {
      message.success('Erfolgreich angemeldet');
      navigate('/');
    } else {
      message.error(result.error);
    }
  };

  return (
    <div className="login-container">
      <SwirlCanvas className="login-swirl" />
      <div className="login-stage">
        <div className="login-hero">
          <img
            src="/logo_black.png"
            alt="Perita Logo"
            className="login-hero-logo"
          />
          <h1 className="login-hero-title wz-wordmark">Wizzy</h1>
          <p className="login-hero-tagline">
            Die <span className="login-hero-accent">Kostensuchmaschine</span> für
            reale Schweizer Bauprojekte.
          </p>
          <p className="login-hero-sub">
            Referenzprojekte, Kennwerte und Kostenschätzungen — in Sekunden.
          </p>
        </div>

        <div className="login-content">
          <Card className="login-card wz-keyline">
            <h2 className="login-subtitle wz-label">Anmeldung</h2>

          <Form
            name="login"
            onFinish={onFinish}
            autoComplete="off"
            layout="vertical"
          >
            <Form.Item
              name="username"
              rules={[{ required: true, message: 'Bitte Benutzername eingeben' }]}
            >
              <Input
                prefix={<UserOutlined />}
                placeholder="Benutzername"
                size="large"
              />
            </Form.Item>

            <Form.Item
              name="password"
              rules={[{ required: true, message: 'Bitte Passwort eingeben' }]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="Passwort"
                size="large"
              />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                block
                size="large"
                className="login-button"
              >
                Anmelden
              </Button>
            </Form.Item>
          </Form>
          </Card>
        </div>
      </div>

      <div className="login-footer">
        <span>by Upatr</span>
        <span className="login-footer-sep" />
        <svg
          className="login-footer-flag"
          viewBox="0 0 32 32"
          role="img"
          aria-label="Schweizer Flagge"
        >
          <rect width="32" height="32" rx="7" fill="#DA291C" />
          <rect x="13.2" y="6.5" width="5.6" height="19" fill="#fff" />
          <rect x="6.5" y="13.2" width="19" height="5.6" fill="#fff" />
        </svg>
        <span>Made in Switzerland</span>
      </div>
    </div>
  );
};

export default Login;